


















































import { Component, Vue } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import CustomForm from '@/components/custom-form/index.vue'
import ExportComRecordApi from '@/api/exportComRecord/index'
import appconst from '@/lib/appconst'
@Component({
  components: {
    CustomForm,
  },
})
export default class ExportComRecord extends AbpBase {
  loading = false
  qrCodeUrl = `${appconst.remoteServiceBaseUrl}/api/WeChatManagement/Weixin/qrcode/`
  pager = {
    pageIndex: 1,
    pageSize: 10,
    total: 0,
  }
  filters = [
    {
      label: '关键字搜索：',
      type: 'input',
      props: {
        placeholder: '',
      },
      key: 'KeyWord',
    },
  ]
  columns1 = [
    {
      title: '表格名称',
      key: 'tableName',
      align: 'center',
    },
    {
      title: '表格状态',
      slot: 'tableState',
      align: 'center',
    },
    // {
    //   title: '表格条件',
    //   key: 'condition',
    //   align: 'center',
    // },
    // {
    //   title: '表格类型',
    //   key: 'tableType',
    //   align: 'center',
    // },
    {
      title: '创建时间',
      slot: 'creationTime',
      align: 'center',
    },
    {
      title: '完成时间',
      slot: 'completeTime',
      align: 'center',
    },
    {
      title: '操作',
      slot: 'action',
      align: 'center',
    },
  ]
  data1 = []
  mounted() {
    this.loadData()
  }
  onPageIndexChange(value) {
    this.pager.pageIndex = value
    let form = (this.$refs.lineForm as any).form
    this.loadData(form)
  }
  submitChange(form, valid) {
    if (valid) {
      this.pager.pageIndex = 1
      this.loadData(form)
    }
  }
  loadData(form = {}) {
    // let keyWord = form['KeyWord']
    this.loading = true
    ExportComRecordApi.getTaskList(this.pager.pageSize, this.pager.pageIndex).then((res) => {
      this.pager.total = res.data.totalCount
      this.data1 = res.data.items
      this.loading = false
    })
  }
  // 下载
  downloadExcel(row) {
    console.log(row)
    let str = row.tableName
    if(str.includes('订单')) {
      ExportComRecordApi.orderTaskDown(row.id).then(res => {
        this.download(res.data, row.tableName)
      })
    }else if(str.includes('佣金')) {
      ExportComRecordApi.distributorTaskDown(row.id).then(res => {
        this.download(res.data, row.tableName)
      })
    }
  }
  download(data, tableName) {
    if (!data) {
      return
    }
    let url = window.URL.createObjectURL(new Blob([data]))
    let link = document.createElement('a')
    link.style.display = 'none'
    link.href = url
    link.setAttribute('download', tableName)

    document.body.appendChild(link)
    link.click()
  }
 
  /**
   * 添加
   */
  // handleAddShop() {
  //   this.$router.push({
  //     name: 'addShop',
  //   })
  // }
}
